import {Component, OnInit} from '@angular/core';
import {ReportingService} from '../../../services/reporting.service';
import {UtilService} from '../../../services/util.service';
import {PermissionService} from '../../../services/permission.service';

@Component({
  selector: 'sb-comp-generated-reports-list',
  templateUrl: './generated-reports-list.component.html',
  styleUrls: ['./generated-reports-list.component.scss'],
  standalone: false,
})
export class GeneratedReportsListComponent implements OnInit {
  constructor(
    public reportingService: ReportingService,
    public util: UtilService,
    public permissionService: PermissionService
  ) {}

  ngOnInit(): void {}
}
